
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">消費税税率 詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_CTR_NEW>{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="$router.go(-1)">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="codeRules"
                clearable
                label="消費税 CD"
                required
                v-model="form.code"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :rules="taxRules"
                clearable
                label="消費税 種類"
                required
                url="/tax-types/kv"
                v-model="form.taxTypeId"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="rateRules"
                clearable
                label="消費税 税率"
                required
                v-model="form.rate"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker label="適応開始日" v-model="form.startDate"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker :min="form.startDate" label="適応終了日" v-model="form.endDate"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker label="国際セグメント適応開始日" v-model="form.freightCalcStartDate"/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <date-picker
                :min="form.freightCalcStartDate"
                label="国際セグメント適応終了日"
                v-model="form.freightCalcEndDate"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null
      },
      taxRules: [v => !!v || '消費税 種類 is required'],
      codeRules: [v => !!v || '消費税 CD is required'],
      nameRules: [v => !!v || '消費税 名称 is required'],
      rateRules: [v => !!v || '消費税 税率 is required']
    }
  },
  methods: {
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'CONSUMPTION_TAX_DATE_ILLEGAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.consumptionTaxDateIllegal')
          )
        } else {
          this.$message('', `system error, module:${this.$route.path}`)
        }
      }
    },
    save() {
      this.$http
        .post('/consumption-tax-rates', this.form)
        .then(() => {
          this.$router.go(-1)
        })
        .catch(this.catch)
    }
  }
}
</script>
